// extracted by mini-css-extract-plugin
export default {"Search":"styles_Search__8IUTc","tabsLinks":"styles_tabsLinks__P3pEN","tabLink":"styles_tabLink__J7ubP","isActive":"styles_isActive__qu06Z","tabs":"styles_tabs__CbbN7"};